import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { BACKEND } from "../../lib/api";

export const absUrl = (u = "") => (u.startsWith("http") ? u : u.startsWith("/api") ? `${BACKEND}${u}` : `${window.location.origin}${u}`);

export const groupByCategory = (items) =>
  items.reduce((acc, it) => ({ ...acc, [it.catName]: [...(acc[it.catName] || []), it] }), {});

export const buildMessage = (items, info) => {
  let n = 0;
  const lines = [`Hi PetalBasket, I'd like to book the following ${items.length} item(s):`, ""];
  Object.entries(groupByCategory(items)).forEach(([cat, list]) => {
    lines.push(`*${cat}*`);
    list.forEach((it) => {
      n += 1;
      lines.push(`${n}. ${it.title}${it.spec ? ` — ${it.spec}` : ""}`, `   ${absUrl(it.url)}`);
    });
    lines.push("");
  });
  if (info.name) lines.push(`Name: ${info.name}`);
  if (info.phone) lines.push(`Phone: ${info.phone}`);
  if (info.date) lines.push(`Event date: ${info.date.split("-").reverse().join("/")}`);
  if (info.venue) lines.push(`Venue: ${info.venue}`);
  return lines.join("\n").trim();
};

export const CartButton = () => {
  const { items } = useCart();
  const { pathname } = useLocation();
  const show = items.length > 0 && pathname !== "/booking-list";
  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0, opacity: 0 }} className="fixed bottom-5 right-5 z-40">
          <Link to="/booking-list" className="flex items-center gap-2 rounded-full bg-gold-foil px-5 py-4 text-sm font-semibold text-[#240620] shadow-[0_20px_50px_-15px_rgba(0,0,0,0.7)]" data-testid="cart-open-btn">
            <ShoppingBag size={18} /> View booking list
            <motion.span key={items.length} initial={{ scale: 1.6 }} animate={{ scale: 1 }} className="flex h-6 min-w-6 items-center justify-center rounded-full bg-[#240620] px-1.5 text-xs text-[#F3E5AB]" data-testid="cart-count">
              {items.length}
            </motion.span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const HeaderCartLink = () => {
  const { items } = useCart();
  return (
    <Link to="/booking-list" className="relative inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#240620]/25 text-[#240620] transition-colors duration-300 hover:bg-[#240620] hover:text-[#FFF8EF]" aria-label="Booking list" data-testid="header-cart-link">
      <ShoppingBag size={18} />
      {items.length > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#E91E63] px-1 text-[10px] font-bold text-white" data-testid="header-cart-count">{items.length}</span>
      )}
    </Link>
  );
};
